import React from 'react';
import './Projects.css';

import matt from './matt.jpg';
import dividino from './dividino.jpg';
import cullen from './ferg.png';

// Same structure, renamed "projects" to show coaches
// Keep your existing image imports:
// import holden from '...';
// import jamieson from '...';
// import cullen from '...';

const projects = [
  {
    title: 'Matt Duarte - Researcher (COSC 4F90)',
    info: `Fourth-year Computer Science student at Brock University specializing in applied machine learning.
    Focused on sports analytics, shot selection in hockey, and predictive modelling.
    This project combines a passion for hockey with data science to explore goal probability and decision-making.`,
    link: '/matt',
    photo: matt, // Placeholder image
  },
  {
    title: 'Dr. Renata Dividino - Supervisor',
    info: `Assistant Professor in the Department of Computer Science at Brock University.
    Her research focuses on graph knowledge representation and machine learning, 
    with applied work in web-scale data and AI transparency.
    Dr. Dividino provides academic guidance and research supervision for this project.`,
    link: '/dividino',
    photo: dividino, // Placeholder image
  },

];

const Projects = () => {
  return (
    <div className="projects">
      <h1>Projects</h1>
      <p>
        A collaborative research effort by <strong>Matt Duarte</strong> (COSC 4F90) under the supervision of
        <strong> Dr. Renata Dividino</strong>, focusing on NHL shot selection, statistical modelling, and machine learning.
      </p>

      {projects.map((project, index) => (
        <a 
          key={index}
        
          className="project-box"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project-content">
            <div className="project-image">
              <img src={project.photo} alt={project.title} />
            </div>
            <div className="project-text">
              <h2>{project.title}</h2>
              <p style={{ whiteSpace: 'pre-line' }}>{project.info}</p>
             
            </div>
          </div>
        </a>
      ))}

      <p style={{ padding: "30px" }}>
        Questions about the research or supervision? Reach out via email.
      </p>
    </div>
  );
};

export default Projects;




